import * as styled from '../styles/marketplace-band';
import { PersonAvatarIcon } from './person-avatar-icon';
import { SectionHeading } from './section-heading';

type Props = {
  tone: 'dark' | 'light';
  kicker: string;
  title: string;
  description: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
  listings: LandingV2.MarketplaceListing[];
};

export const MarketplaceBand = ({
  tone,
  kicker,
  title,
  description,
  ctaLabel,
  onCtaClick,
  listings,
}: Props) => (
  <styled.OuterPad>
    <styled.Panel $tone={tone}>
      <styled.Left>
        <SectionHeading kicker={kicker} title={title} subtitle={description} onDark={tone === 'dark'} />
        {ctaLabel && onCtaClick && (
          <styled.Cta type="button" $tone={tone} onClick={onCtaClick}>
            {ctaLabel}
          </styled.Cta>
        )}
      </styled.Left>
      <styled.ListingStack>
        {listings.map((listing) => (
          <styled.ListingCard key={listing.title} $tone={tone}>
            <styled.ListingAvatar $background={listing.avatarBg}>
              <PersonAvatarIcon variant={listing.avatarVariant} size={36} color={listing.avatarFg} />
            </styled.ListingAvatar>
            <styled.ListingBody>
              <styled.ListingTitle $tone={tone}>{listing.title}</styled.ListingTitle>
              <styled.ListingSubtitle $tone={tone}>{listing.subtitle}</styled.ListingSubtitle>
            </styled.ListingBody>
            <styled.ListingChevron>→</styled.ListingChevron>
          </styled.ListingCard>
        ))}
      </styled.ListingStack>
    </styled.Panel>
  </styled.OuterPad>
);
